import { computeCamLayoutRects, pctRectStyle, type CamLayoutConfig } from '@/lib/camLayouts';
import { cn } from '@/lib/utils';

const ASSETS = `${import.meta.env.BASE_URL}assets/cam-layout`;
const PRESENTER_PHOTOS = 9;

/**
 * Aperçu de la zone vidéo seule (scène 16:9) : slide + vignettes photo aux rectangles calculés par
 * la disposition, les mêmes que le compositor. Les rayons suivent la largeur du conteneur (`cqw`),
 * l'aperçu reste homothétique quelle que soit sa taille.
 */
export default function CamLayoutPreview({
  config,
  presenterCount,
  className,
}: {
  config: CamLayoutConfig;
  presenterCount: number;
  className?: string;
}) {
  const rects = computeCamLayoutRects(config, presenterCount, true);
  return (
    <div className={cn('w-full [container-type:inline-size]', className)}>
      <div className="relative aspect-video w-full overflow-hidden bg-[#0C0E21]">
        {rects.content && (
          <img
            src={`${ASSETS}/slide.webp`}
            alt=""
            className="absolute object-cover"
            style={{
              ...pctRectStyle(rects.content),
              borderRadius: `${rects.contentRadiusPx / 19.2}cqw`,
            }}
          />
        )}
        {rects.cams.map((rect, index) => (
          <img
            key={index}
            src={`${ASSETS}/presenter-${(index % PRESENTER_PHOTOS) + 1}.webp`}
            alt=""
            className="absolute z-10 object-cover"
            style={{ ...pctRectStyle(rect), borderRadius: `${rects.camRadiusPx / 19.2}cqw` }}
          />
        ))}
      </div>
    </div>
  );
}
